import {getMockup} from './variant-logic.js';
import {priceFor,validateChoice,createCartApi} from './noisterra-core.js';
const codeByName={"WHITE":"WH","BLACK":"BK","RED":"RD","NAVY":"NY","ROYAL BLUE":"RB","ASH MELANGE":"AS","BOTTLE GREEN":"BG","GRAPHITE":"GF","GREY MELANGE":"GM","ORANGE":"OR","GOLD":"SY","CARDINAL":"CA"};
const live=window.NOISTERRA_SHOPIFY===true;const api=createCartApi(window.fetch.bind(window),window.Shopify?.routes?.root||'/');
const liveProducts=window.NOISTERRA_PRODUCTS||[];let cartBusy=false;
const safe=s=>String(s).replaceAll('&','&amp;').replaceAll('<','&lt;').replaceAll('>','&gt;').replaceAll('"','&quot;');
const products = [
  {
    "id": 11,
    "handle": "des-01",
    "designId": "DES-01",
    "title": "Estoy que exploto",
    "phrase": "ESTOY QUE EXPLOTO",
    "category": "vida",
    "image": "./assets/DES-01.png",
    "print": "./assets/DES-01.png",
    "price": 18
  },
  {
    "id": 12,
    "handle": "des-02",
    "designId": "DES-02",
    "title": "Plan de futuro",
    "phrase": "TENGO UN PLAN DE FUTURO. LLEGAR AL VIERNES.",
    "category": "vida",
    "image": "./assets/DES-02.png",
    "print": "./assets/DES-02.png",
    "price": 18
  },
  {
    "id": 13,
    "handle": "des-03",
    "designId": "DES-03",
    "title": "No es estrés",
    "phrase": "¡NO ES ESTRÉS!",
    "category": "energia",
    "image": "./assets/DES-03.png",
    "print": "./assets/DES-03.png",
    "price": 18
  },
  {
    "id": 14,
    "handle": "des-04",
    "designId": "DES-04",
    "title": "No me pasa nada",
    "phrase": "NO ME PASA NADA mepasatodojunto.",
    "category": "vida",
    "image": "./assets/DES-04.png",
    "print": "./assets/DES-04.png",
    "price": 18
  },
  {
    "id": 15,
    "handle": "des-05",
    "designId": "DES-05",
    "title": "Me sobra mes",
    "phrase": "DÍA 17 ME SOBRA MES AL FINAL DEL SUELDO",
    "category": "trabajo",
    "image": "./assets/DES-05.png",
    "print": "./assets/DES-05.png",
    "price": 18
  },
  {
    "id": 16,
    "handle": "des-06",
    "designId": "DES-06",
    "title": "Margen de mejora",
    "phrase": "TENGO MARGEN DE MEJORA. Y pienso conservarlo.",
    "category": "vida",
    "image": "./assets/DES-06.png",
    "print": "./assets/DES-06.png",
    "price": 18
  }
];

const colorOptions = [["WHITE","#ffffff"],["BLACK","#2e2b26"],["RED","#cd0e2d"],["NAVY","#002a3a"],["ROYAL BLUE","#0055b8"],["ASH MELANGE","#c9c5bf"],["BOTTLE GREEN","#14572c"],["GRAPHITE","#545454"],["GREY MELANGE","#706d66"],["ORANGE","#ff671c"],["GOLD","#ffd600"],["CARDINAL","#572a31"]];
const saleColors={"DES-02":"BLACK","DES-03":"BOTTLE GREEN","DES-05":"WHITE"};

if(window.NOISTERRA_ASSETS){for(const p of products){p.image=window.NOISTERRA_ASSETS[p.designId];p.print=p.image;p.image=getMockup(window.NOISTERRA_VARIANTS,p.designId,codeByName[saleColors[p.designId]]||'WH').url;}}
const state = { cart: [], activeProduct: null, filter: "all" };
const money = value => new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(value);

const productGrid = document.querySelector("#productGrid");
const productDialog = document.querySelector("#productDialog");
const productForm = document.querySelector("#productForm");
const cartDrawer = document.querySelector("#cartDrawer");
const drawerBackdrop = document.querySelector("#drawerBackdrop");
const toast = document.querySelector("#toast");
const colorGrid = document.querySelector("#colorGrid");
const colorInput = document.querySelector("#colorInput");
const selectedSwatch = document.querySelector("#selectedSwatch");
const selectedColorName = document.querySelector("#selectedColorName");
const liveMockup = document.querySelector("#liveMockup");
const dialogPrint = document.querySelector("#dialogPrint");
const mockupColorLabel = document.querySelector("#mockupColorLabel");

const priorityColors=["WHITE","BLACK","RED","NAVY","ROYAL BLUE","ASH MELANGE","BOTTLE GREEN","GRAPHITE","GREY MELANGE","ORANGE","GOLD","CARDINAL"];
const displayedColors = [...colorOptions].sort((a, b) => {
  const aIndex = priorityColors.indexOf(a[0]);
  const bIndex = priorityColors.indexOf(b[0]);
  if (aIndex !== -1 || bIndex !== -1) return (aIndex === -1 ? 999 : aIndex) - (bIndex === -1 ? 999 : bIndex);
  return a[0].localeCompare(b[0]);
});

colorGrid.innerHTML = displayedColors.map(([name, hex]) => `
  <button class="color-choice" type="button" role="radio" aria-checked="false" data-color="${name}" title="${name}">
    <span class="color-choice__swatch" style="--swatch:${hex}" aria-hidden="true"></span>
    <span class="color-choice__name">${name}</span>
  </button>
`).join("");

let imageVersion=0;
function updateColorPreview(colorName=colorInput.value){
 if(state.activeProduct&&['DES-02','DES-05'].includes(state.activeProduct.designId)&&['RED','CARDINAL'].includes(colorName)){showToast('Color no disponible para este diseño');return;}
 const selected=colorOptions.find(([name])=>name===colorName);
 if(!selected){showToast('Color no disponible');return;}
 colorInput.value=selected[0];selectedSwatch.style.background=selected[1];selectedColorName.textContent=selected[0];
 colorGrid.querySelectorAll('.color-choice').forEach(b=>b.setAttribute('aria-checked',String(b.dataset.color===selected[0])));
 if(!state.activeProduct)return;
 const code=codeByName[selected[0]];const version=++imageVersion;const image=document.querySelector('#dialogModel');
 try{
  const entry=getMockup(window.NOISTERRA_VARIANTS,state.activeProduct.designId,code);
  if(entry.detail){const detail=document.querySelector('#puffDialog img');detail.src=entry.detail;detail.alt='Detalle puff de EXPLOTO en camiseta '+selected[0];}
  image.dataset.color=code;image.dataset.design=entry.design;image.style.opacity='.4';
  mockupColorLabel.textContent='Cargando '+selected[0]+'…';
  image.onload=()=>{if(version!==imageVersion)return;image.style.opacity='1';mockupColorLabel.textContent='Mockup en '+selected[0]+' · '+'contraste revisado';};
  image.onerror=()=>{if(version!==imageVersion)return;image.style.opacity='0';mockupColorLabel.textContent='Imagen de este color no disponible';};
  image.alt='Mockup: '+state.activeProduct.title+' sobre camiseta '+selected[0];image.src=entry.url;
  if(image.complete&&image.naturalWidth>0)image.onload();
  liveMockup.setAttribute('aria-label',image.alt);
 }catch(e){image.removeAttribute('src');mockupColorLabel.textContent=e.message;}
}

function renderProducts() {
  const visible = products.filter(product => saleColors[product.designId] && (state.filter === "all" || product.category === state.filter));
  document.querySelector("#visibleCount").textContent = visible.length;
  productGrid.innerHTML = visible.map(product => `
    <article class="product-card" data-category="${product.category}">
      <button class="product-card__visual" type="button" data-open-product="${product.id}" aria-label="Ver ${product.title}">
        <span class="product-number">${product.id}</span>
        <span class="product-demo">ORIGINAL</span>
        <img src="${product.image}" alt="Mockup con modelo: ${product.title}" width="900" height="540" loading="lazy" />
      </button>
      <div class="product-card__info">
        <h3>${product.title}</h3>
        <span class="product-card__price">${money(product.price)}</span>
        <p>${product.phrase}</p>
        <div class="mini-swatches" aria-label="Colores disponibles">
          ${colorOptions.filter(([name])=>name===saleColors[product.designId]).map(([, hex]) => `<i style="background:${hex}"></i>`).join("")}
          <span>1 color</span>
        </div>
        <button class="quick-add" type="button" data-open-product="${product.id}">Elegir talla y color →</button>
      </div>
    </article>
  `).join("");
}

function openProduct(id) {
  const product = products.find(item => item.id === Number(id));
  if (!product || !saleColors[product.designId]) return;
  state.activeProduct = product;
  const chosenColor=saleColors[product.designId];
  colorGrid.querySelectorAll('[data-color]').forEach(b=>{b.hidden=b.dataset.color!==chosenColor;});
  dialogPrint.src = product.print;
 const puff=document.querySelector("#puffDetailButton");if(puff)puff.hidden=product.designId!=='DES-01';
 document.querySelector("#productionNote").textContent=product.designId==='DES-01'?'EXPLOTO de 19,5 cm de ancho con acabado puff en relieve; ESTOY QUE con impresión plana. Mockup ilustrativo: validar el acabado con una muestra física.':'Estampado integrado en la prenda. Mockup ilustrativo; escala según medidas de archivo confirmadas.';
  dialogPrint.alt = "";
  document.querySelector("#dialogNumber").textContent = `Drop 001 · Diseño ${product.id}`;
  document.querySelector("#dialogTitle").textContent = product.title;
  document.querySelector("#dialogPhrase").textContent = product.phrase;
  document.querySelector("#dialogPrice").textContent = money(product.price);
  productForm.reset();
  colorInput.value = chosenColor;
  updateColorPreview(chosenColor);
  colorGrid.scrollTop = 0;
  productDialog.showModal();
}

function closeProduct() {
  if (productDialog.open) productDialog.close();
}

async function refreshCart(){const cart=await api.read();state.cart=cart.items.map(i=>({key:i.key,product:{title:safe(i.product_title),image:i.image||'',price:i.final_price/100},size:safe(i.options_with_values?.find(o=>o.name==='Talla')?.value||''),color:safe(i.options_with_values?.find(o=>o.name==='Color')?.value||''),qty:i.quantity,unitPrice:i.final_price/100}));renderCart();}
async function addToCart(product,size,color){
 if(window.NOISTERRA_CATALOG_ONLY)throw Error("Pedidos próximamente. Contacto: info@noisterra.com");
 if(!saleColors[product.designId]||color!==saleColors[product.designId])throw Error('Color no disponible para este diseño');
 validateChoice(size,codeByName[color]);
 if(live){const p=liveProducts.find(p=>p.handle===product.handle);const v=p?.variants?.find(v=>v.options[0]===size&&v.options[1]===codeByName[color]);if(!v||!v.available)throw Error('Esta variante todavía no está disponible en Shopify');if(Number(v.price)!==priceFor(size))throw Error('El precio de Shopify no coincide con el autorizado');await api.add(v.id,1);await refreshCart();}
 else{const key=product.id+'-'+size+'-'+color;const old=state.cart.find(i=>i.key===key);if(old){if(old.qty>=99)throw Error('Máximo 99 unidades');old.qty++;}else state.cart.push({key,product,size,color,qty:1,unitPrice:priceFor(size)/100});renderCart();}
 showToast(product.title+' · talla '+size+' añadida a la bolsa.');
}

function renderCart() {
  const count = state.cart.reduce((sum, item) => sum + item.qty, 0);
  const subtotal = state.cart.reduce((sum, item) => sum + item.unitPrice * item.qty, 0);
  const countNode = document.querySelector("#cartCount");
  countNode.textContent = count;
  countNode.setAttribute("aria-label", `${count} ${count === 1 ? "producto" : "productos"}`);
  document.querySelector("#subtotal").textContent = money(subtotal);
  const items = document.querySelector("#cartItems");
  if (!state.cart.length) {
    items.innerHTML = `<div class="empty-cart"><div><strong>La bolsa está descansando.</strong><p>Añade una camiseta cuando te apetezca.</p></div></div>`;
    return;
  }
  items.innerHTML = state.cart.map(item => `
    <article class="cart-item">
      <img src="${item.product.image}" alt="" />
      <div>
        <h3>${item.product.title}</h3>
        <p>${item.color} · ${item.size}</p>
        <div class="cart-item__qty" aria-label="Cantidad">
          <button type="button" data-qty="down" data-key="${item.key}" aria-label="Quitar una unidad">−</button>
          <span>${item.qty}</span>
          <button type="button" data-qty="up" data-key="${item.key}" aria-label="Añadir una unidad">+</button>
        </div>
        <div class="cart-item__price">${money(item.unitPrice * item.qty)}</div>
      </div>
      <button class="cart-item__remove" type="button" data-remove="${item.key}">Quitar</button>
    </article>
  `).join("");
}

function openCart() {
  drawerBackdrop.hidden = false;
  requestAnimationFrame(() => drawerBackdrop.classList.add("is-visible"));
  cartDrawer.classList.add("is-open");
  cartDrawer.setAttribute("aria-hidden", "false");
  document.querySelector("#openCart").setAttribute("aria-expanded", "true");
  document.body.classList.add("is-locked");
  document.querySelector("#closeCart").focus();
}

function closeCart() {
  cartDrawer.classList.remove("is-open");
  drawerBackdrop.classList.remove("is-visible");
  cartDrawer.setAttribute("aria-hidden", "true");
  document.querySelector("#openCart").setAttribute("aria-expanded", "false");
  document.body.classList.remove("is-locked");
  setTimeout(() => { drawerBackdrop.hidden = true; }, 260);
}

let toastTimer;
function showToast(message) {
  clearTimeout(toastTimer);
  toast.textContent = message;
  toast.setAttribute("aria-hidden", "false");
  toast.classList.add("is-visible");
  toastTimer = setTimeout(() => {
    toast.classList.remove("is-visible");
    toast.setAttribute("aria-hidden", "true");
  }, 3200);
}

document.addEventListener("click", async event => {
  const openButton = event.target.closest("[data-open-product]");
  if (openButton) openProduct(openButton.dataset.openProduct);

  const filterButton = event.target.closest("[data-filter]");
  if (filterButton) {
    state.filter = filterButton.dataset.filter;
    document.querySelectorAll(".filter").forEach(button => button.classList.toggle("is-active", button === filterButton));
    renderProducts();
  }

  const removeButton = event.target.closest("[data-remove]");
  if(removeButton){if(cartBusy)return;if(live){cartBusy=true;try{await api.change(removeButton.dataset.remove,0);await refreshCart();}catch(e){showToast(e.message);}finally{cartBusy=false;}}else{state.cart=state.cart.filter(i=>i.key!==removeButton.dataset.remove);renderCart();}}

  const qtyButton = event.target.closest("[data-qty]");
  if (qtyButton) {
    const item = state.cart.find(entry => entry.key === qtyButton.dataset.key);
    if (!item) return;
    const qty=item.qty+(qtyButton.dataset.qty==='up'?1:-1);if(qty>99||cartBusy)return;if(live){cartBusy=true;try{await api.change(item.key,qty);await refreshCart();}catch(e){showToast(e.message);}finally{cartBusy=false;}}else{item.qty=qty;if(qty<=0)state.cart=state.cart.filter(i=>i.key!==item.key);renderCart();}
  }
});

productForm.addEventListener("submit", async event => {
  event.preventDefault();
  if (!state.activeProduct) return;
  const formData = new FormData(productForm);
  if(cartBusy)return;cartBusy=true;const button=productForm.querySelector('button[type="submit"]');button.disabled=true;try{await addToCart(state.activeProduct,formData.get('size'),formData.get('color'));closeProduct();}catch(e){showToast(e.message);}finally{cartBusy=false;button.disabled=false;}
});

document.querySelector("#openCart").addEventListener("click", openCart);
document.querySelector("#closeCart").addEventListener("click", closeCart);
document.querySelector("#closeDialog").addEventListener("click", closeProduct);
drawerBackdrop.addEventListener("click", closeCart);
productDialog.addEventListener("click", event => {
  if (event.target === productDialog) closeProduct();
});
document.querySelector('#checkoutButton').addEventListener('click',()=>{if(window.NOISTERRA_CATALOG_ONLY){showToast('Pedidos próximamente.');return;}if(!live){showToast('Vista previa: no se tramitan pedidos.');return;}if(!state.cart.length){showToast('Tu bolsa está vacía.');return;}location.assign((window.Shopify?.routes?.root||'/')+'checkout');});
colorGrid.addEventListener("click", event => {
  const button = event.target.closest("[data-color]");
  if (button) updateColorPreview(button.dataset.color);
});
document.addEventListener("keydown", event => {
  if (event.key === "Escape" && cartDrawer.classList.contains("is-open")) closeCart();
});

renderProducts();
renderCart();
updateColorPreview("WHITE");

productForm.addEventListener('change',()=>{const size=new FormData(productForm).get('size');if(size)document.querySelector('#dialogPrice').textContent=money(priceFor(size)/100);});
if(live){document.querySelector('#checkoutButton').textContent=window.NOISTERRA_CATALOG_ONLY?'Pedidos próximamente':'Finalizar pedido';refreshCart().then(()=>{if(window.NOISTERRA_PAGE_TYPE==='cart')openCart();if(window.NOISTERRA_PRODUCT_HANDLE){const p=products.find(p=>p.handle===window.NOISTERRA_PRODUCT_HANDLE);if(p)openProduct(p.id);}}).catch(e=>showToast(e.message));}

const puffDialog=document.querySelector('#puffDialog');document.querySelector('#puffDetailButton').addEventListener('click',()=>puffDialog.showModal());document.querySelector('#closePuff').addEventListener('click',()=>puffDialog.close());puffDialog.addEventListener('click',e=>{if(e.target===puffDialog)puffDialog.close();});
